import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useCart } from '../../hooks/useCart';

const PRODUCT_IMAGE = 'https://storage.readdy-site.link/project_files/fbdeed4b-ebea-4a2a-94ca-d34ec0e1d4bd/7ad78983-aefe-41f7-b4d3-88ca4307df6f_oeuf-de-paques.png?v=61fae6b07adf3462af91e7213e4412af';

const ProduitOeufPaquesLivrePlie = () => {
  const navigate = useNavigate();
  const { addItem } = useCart();
  const [quantity, setQuantity] = useState(1);
  const [showNotification, setShowNotification] = useState(false);

  const product = {
    id: 'oeuf-paques-livre-plie',
    title: 'Œuf de Pâques en livre plié (pièce unique)',
    price: 9,
    stock: 1,
    shortDescription: 'Un petit œuf décoratif en livre plié, fait main, poétique et léger. Parfait pour une décoration de Pâques douce.',
  };

  const handleAddToCart = () => {
    addItem({
      id: product.id,
      name: product.title,
      price: product.price,
      image: PRODUCT_IMAGE,
      description: product.shortDescription,
    });
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 3000);
  };

  const handleBuyNow = () => {
    handleAddToCart();
    setTimeout(() => navigate('/panier'), 300);
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    document.title = 'Œuf de Pâques en livre plié – Déco Printemps | Les Carnets de Lolotte';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Œuf décoratif en livre plié, fait main, pièce unique. Petite déco poétique pour Pâques et le printemps – Les Carnets de Lolotte.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'oeuf pâques livre plié, déco pâques artisanale, décoration printemps, art papier, pièce unique, upcycling, fait main');
    }

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', 'Œuf de Pâques en livre plié – Déco Printemps | Les Carnets de Lolotte');

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) ogDescription.setAttribute('content', 'Œuf décoratif en livre plié, fait main, pièce unique. Petite déco poétique pour Pâques et le printemps – Les Carnets de Lolotte.');

    const ogImage = document.querySelector('meta[property="og:image"]');
    if (ogImage) ogImage.setAttribute('content', PRODUCT_IMAGE);

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', 'https://lescarnetsdelolotte.com/produit-oeuf-paques-livre-plie');

    const jsonLd = {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: product.title,
      image: [PRODUCT_IMAGE],
      description: product.shortDescription,
      brand: {
        '@type': 'Brand',
        name: 'Les Carnets de Lolotte',
      },
      offers: {
        '@type': 'Offer',
        url: 'https://lescarnetsdelolotte.com/produit-oeuf-paques-livre-plie',
        priceCurrency: 'EUR',
        price: product.price,
        availability: product.stock > 0 ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
        itemCondition: 'https://schema.org/NewCondition',
      },
    };

    let scriptTag = document.querySelector('script[type="application/ld+json"]');
    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.setAttribute('type', 'application/ld+json');
      document.head.appendChild(scriptTag);
    }
    scriptTag.textContent = JSON.stringify(jsonLd);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FDF8F5] via-white to-[#FDF8F5]">
      <Header />

      {showNotification && (
        <div className="fixed top-24 right-6 bg-[#B97A72] text-white px-6 py-4 rounded-lg z-50 flex items-center gap-3">
          <div className="w-6 h-6 flex items-center justify-center">
            <i className="ri-check-line text-xl"></i>
          </div>
          <span className="font-medium" style={{ fontFamily: 'Poppins, sans-serif' }}>Produit ajouté au panier !</span>
        </div>
      )}

      <main className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-6">

          {/* Fil d'Ariane */}
          <nav className="mb-8 text-sm text-[#8B7D6C]" style={{ fontFamily: 'Poppins, sans-serif' }}>
            <Link to="/boutique" className="hover:text-[#B97A72] transition-colors">Boutique</Link>
            <span className="mx-2">›</span>
            <Link
              to="/boutique"
              className="hover:text-[#B97A72] transition-colors"
              onClick={() => sessionStorage.setItem('boutiqueCategory', 'Printemps & Pâques')}
            >
              Printemps &amp; Pâques
            </Link>
            <span className="mx-2">›</span>
            <span className="text-[#6B5E5A]">Œuf de Pâques en livre plié</span>
          </nav>

          <div className="grid lg:grid-cols-2 gap-16 items-start">

            {/* Image principale */}
            <div>
              <div
                className="relative bg-[#FAF9F8] rounded-2xl overflow-hidden border border-[#EDD9D4]"
                style={{ aspectRatio: '1/1' }}
              >
                <img
                  src={PRODUCT_IMAGE}
                  alt="Œuf de Pâques en livre plié – création artisanale fait main"
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-4 left-4">
                  <span
                    className="bg-[#C49B86] text-white px-4 py-1.5 rounded-full text-sm font-medium"
                    style={{ fontFamily: 'Playfair Display, serif' }}
                  >
                    ✨ Pièce unique
                  </span>
                </div>
              </div>
            </div>

            {/* Informations produit */}
            <div className="space-y-8">

              <div>
                <p
                  className="text-sm text-[#B97A72] font-medium mb-2 uppercase tracking-wider"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  Décoration Pâques &amp; Printemps
                </p>
                <h1
                  className="text-4xl lg:text-5xl font-bold text-[#6B5E5A] mb-4"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  {product.title}
                </h1>
                <p
                  className="text-lg text-[#8B7D6C] leading-relaxed"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  {product.shortDescription}
                </p>
              </div>

              {/* Prix */}
              <div className="flex items-baseline gap-3">
                <span
                  className="text-5xl font-bold text-[#B97A72]"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  {product.price} €
                </span>
                <span className="text-sm text-[#8B7D6C]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Frais de livraison calculés au panier
                </span>
              </div>

              {/* Encart pièce unique */}
              <div className="bg-[#FDF4F0] border border-[#EDD9D4] rounded-xl p-5 flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-star-fill text-[#C49B86] text-2xl"></i>
                </div>
                <div>
                  <p className="font-semibold text-[#6B5E5A] mb-1" style={{ fontFamily: 'Playfair Display, serif' }}>
                    Pièce unique – 1 exemplaire disponible
                  </p>
                  <p className="text-sm text-[#8B7D6C]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    Cette création est unique. Une fois vendue, elle ne sera plus disponible. Chaque pièce est réalisée à la main : de légères variations font son charme.
                  </p>
                </div>
              </div>

              {/* Sélecteur quantité */}
              <div className="space-y-4">
                <div className="flex items-center gap-4">
                  <label className="text-[#6B5E5A] font-medium" style={{ fontFamily: 'Poppins, sans-serif' }}>Quantité :</label>
                  <div className="flex items-center border border-[#EDD9D4] rounded-lg overflow-hidden bg-white">
                    <button
                      onClick={() => setQuantity(Math.max(1, quantity - 1))}
                      disabled={quantity <= 1}
                      className="px-4 py-2 text-[#8B7D6C] hover:text-[#B97A72] transition-colors disabled:opacity-40 cursor-pointer"
                    >
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-subtract-line"></i>
                      </div>
                    </button>
                    <span
                      className="px-4 py-2 text-[#6B5E5A] font-semibold min-w-[2.5rem] text-center"
                      style={{ fontFamily: 'Poppins, sans-serif' }}
                    >
                      {quantity}
                    </span>
                    <button
                      onClick={() => setQuantity(Math.min(product.stock, quantity + 1))}
                      disabled={quantity >= product.stock}
                      className="px-4 py-2 text-[#8B7D6C] hover:text-[#B97A72] transition-colors disabled:opacity-40 cursor-pointer"
                    >
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-add-line"></i>
                      </div>
                    </button>
                  </div>
                  <span className="text-sm text-[#8B7D6C]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    (1 disponible)
                  </span>
                </div>

                <div className="flex gap-3">
                  <button
                    onClick={handleAddToCart}
                    className="flex-1 border-2 border-[#B97A72] text-[#B97A72] px-6 py-3.5 rounded-lg font-medium hover:bg-[#FDF4F0] transition-all duration-200 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
                    style={{ fontFamily: 'Playfair Display, serif' }}
                  >
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-shopping-cart-line"></i>
                    </div>
                    Ajouter au panier
                  </button>
                  <button
                    onClick={handleBuyNow}
                    className="flex-1 bg-[#B97A72] text-white px-6 py-3.5 rounded-lg font-medium hover:bg-[#C49B86] transition-all duration-200 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
                    style={{ fontFamily: 'Playfair Display, serif' }}
                  >
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-flashlight-line"></i>
                    </div>
                    Acheter maintenant
                  </button>
                </div>
              </div>

              {/* Garanties */}
              <div className="border-t border-[#EDD9D4] pt-6 space-y-3">
                {[
                  { icon: 'ri-truck-line', text: 'Livraison soignée et sécurisée' },
                  { icon: 'ri-gift-line', text: 'Emballage soigné, prêt à offrir' },
                  { icon: 'ri-france-line', text: 'Création artisanale faite main en France' },
                ].map(({ icon, text }) => (
                  <div key={text} className="flex items-center gap-3 text-[#8B7D6C]" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    <div className="w-5 h-5 flex items-center justify-center text-[#B97A72]">
                      <i className={icon}></i>
                    </div>
                    <span className="text-sm">{text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Description longue */}
          <div className="mt-20 max-w-4xl mx-auto space-y-8">

            <section className="bg-white border border-[#EDD9D4] rounded-2xl p-8">
              <h2
                className="text-3xl font-bold text-[#6B5E5A] mb-6 flex items-center gap-3"
                style={{ fontFamily: 'Playfair Display, serif' }}
              >
                <div className="w-7 h-7 flex items-center justify-center text-[#B97A72]">
                  <i className="ri-sparkling-line text-2xl"></i>
                </div>
                La création
              </h2>
              <p
                className="text-[#8B7D6C] text-lg leading-relaxed mb-6"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                Cet œuf de Pâques est une création artisanale réalisée à partir d'un livre recyclé, plié à la main. Un petit objet décoratif plein de charme, idéal pour une table de Pâques, une étagère ou une petite attention.
              </p>
              <ul className="space-y-3">
                {[
                  'Pièce unique',
                  'Fait main en France',
                  'Livre recyclé (upcycling)',
                ].map((item) => (
                  <li
                    key={item}
                    className="flex items-center gap-3 text-[#8B7D6C]"
                    style={{ fontFamily: 'Poppins, sans-serif' }}
                  >
                    <div className="w-5 h-5 flex items-center justify-center text-[#B97A72] flex-shrink-0">
                      <i className="ri-checkbox-circle-fill"></i>
                    </div>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </section>

            <section className="bg-[#FDF4F0] border border-[#EDD9D4] rounded-2xl p-8">
              <h2
                className="text-3xl font-bold text-[#6B5E5A] mb-6 flex items-center gap-3"
                style={{ fontFamily: 'Playfair Display, serif' }}
              >
                <div className="w-7 h-7 flex items-center justify-center text-[#B97A72]">
                  <i className="ri-information-line text-2xl"></i>
                </div>
                Caractéristiques
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {[
                  { label: 'Type', value: 'Décoration en livre plié' },
                  { label: 'Saison', value: 'Pâques / Printemps' },
                  { label: 'Pièce', value: 'Unique' },
                  { label: 'Dimensions', value: 'À renseigner' },
                ].map(({ label, value }) => (
                  <div key={label} className="bg-white rounded-lg p-4 border border-[#EDD9D4]">
                    <p className="text-xs text-[#B97A72] font-medium uppercase tracking-wide mb-1" style={{ fontFamily: 'Poppins, sans-serif' }}>{label}</p>
                    <p className="text-[#6B5E5A] font-medium" style={{ fontFamily: 'Playfair Display, serif' }}>{value}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="bg-white border border-[#EDD9D4] rounded-2xl p-8">
              <h2
                className="text-3xl font-bold text-[#6B5E5A] mb-4 flex items-center gap-3"
                style={{ fontFamily: 'Playfair Display, serif' }}
              >
                <div className="w-7 h-7 flex items-center justify-center text-[#B97A72]">
                  <i className="ri-gift-2-line text-2xl"></i>
                </div>
                Idées cadeau
              </h2>
              <p
                className="text-[#8B7D6C] text-lg leading-relaxed"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                Idéal pour une déco de printemps ou un petit cadeau. Table de Pâques, étagère poétique, petite attention originale à offrir pour les fêtes de printemps.
              </p>
            </section>

          </div>

          {/* CTA retour boutique */}
          <div className="mt-16 text-center">
            <Link
              to="/boutique"
              className="inline-flex items-center gap-2 border-2 border-[#B97A72] text-[#B97A72] px-8 py-3 rounded-full hover:bg-[#FDF4F0] transition-colors font-medium whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-left-line"></i>
              </div>
              Retour à la boutique
            </Link>
          </div>

        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ProduitOeufPaquesLivrePlie;
